<router-outlet name="auth"></router-outlet>
<router-outlet name="slider"></router-outlet>

<div class="grid-design">
  <header class="space"></header>
  <jumbotron class="space" *ngIf="isRootPage"></jumbotron>
  <div class="space content-sapce">
    <div class="content-grid layout-corral">
      <left-content *ngIf="currentPage"></left-content>
      <div class="main-content">
        <router-outlet></router-outlet>
      </div>
      <right-content *ngIf="currentPage"></right-content>
    </div>
  </div>
  <footer class="space"></footer>
  <!-- <footer class="space"></footer> -->
</div>
<fullscreen-gallery></fullscreen-gallery>
<cms-dialog dir="ltr"></cms-dialog>
